import { PropsWithChildren } from 'react'

import { Divider, Flex, Skeleton, Typography } from 'antd'
import { useTheme } from 'antd-style'

import { DataError } from '@eastcoal/common/components/DataError'

import { ArticleSkeletonProps } from './interface'

export const ArticleSkeleton = ({
  title,
  subtitle,
  extra,
  children,
  error,
  loading,
  reload
}: PropsWithChildren<ArticleSkeletonProps>) => {
  const theme = useTheme()

  return error ? (
    <Flex justify='center'>
      <DataError error={error} reload={reload} />
    </Flex>
  ) : (
    <Skeleton loading={loading}>
      <Flex align='flex-end' justify='space-between' wrap='nowrap'>
        <div>
          <Typography.Title level={4}>{title}</Typography.Title>
          <Typography.Text type='secondary'>{subtitle}</Typography.Text>
        </div>
        {extra}
      </Flex>
      <Divider
        orientation='horizontal'
        style={{
          marginBlock: theme.margin
        }}
      />
      {children}
    </Skeleton>
  )
}
